export interface VatLineAmounts {
  subTotal: number;
  vatAmount: number;
  total: number;
}

/** ใช้เฉพาะตอนยังโหลดอัตราจาก API (getVatSetting) ไม่สำเร็จ — ค่าจริงอยู่ที่ city_parking_vat_rate */
export const VAT_FALLBACK_RATE_PERCENT = 7;

/**
 * ปัด 2 ตำแหน่งแบบครึ่งขึ้น (ห่างจากศูนย์) ให้ตรง API MidpointRounding.AwayFromZero
 * toPrecision(15) ตัด error ของ floating point เช่น 1.015 * 100 = 101.49999999999999
 */
export function roundMoney(value: number): number {
  if (!Number.isFinite(value)) return 0;
  const shifted = Number((Math.abs(value) * 100).toPrecision(15));
  return (Math.sign(value) * Math.round(shifted)) / 100;
}

/** ยอดรวม VAT แล้ว → แยก (สูตรเดียวกับ VatAmountHelper.FromInclusive ฝั่ง API) */
export function extractVatFromInclusive(gross: number, ratePercent: number): VatLineAmounts {
  const total = roundMoney(gross || 0);
  const vatAmount = roundMoney(total * ratePercent / (100 + ratePercent));
  return { subTotal: roundMoney(total - vatAmount), vatAmount, total };
}

/** ยอดก่อน VAT → บวก VAT (สูตรเดียวกับ VatAmountHelper.FromExclusive ฝั่ง API) */
export function addVatToExclusive(net: number, ratePercent: number): VatLineAmounts {
  const subTotal = roundMoney(net || 0);
  const vatAmount = roundMoney(subTotal * ratePercent / 100);
  return { subTotal, vatAmount, total: roundMoney(subTotal + vatAmount) };
}

/** 7 → "7" · 7.5 → "7.5" */
export function formatVatRate(ratePercent: number): string {
  return String(roundMoney(ratePercent));
}

/** Aligns with ConfirmPaymentRegisterGroupAsync / CalculateMemberFeeAsync on Platform API. */
export function calculateVatLineAmounts(
  unitFee: number,
  quantity: number,
  vat: boolean,
  vatIncluded: boolean,
  ratePercent: number,
): VatLineAmounts {
  const qty = Math.max(quantity, 0);
  const base = (unitFee || 0) * qty;

  if (!vat) {
    return { subTotal: base, vatAmount: 0, total: base };
  }

  return vatIncluded
    ? extractVatFromInclusive(base, ratePercent)
    : addVatToExclusive(base, ratePercent);
}
